import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";
import { of, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SlotChangeService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.changeSlot();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(incrementId: string, dateType: string, slotId: number): any {
    const params: any = {
      order_id: incrementId,
      delivery_date: dateType,
      slot_id: slotId,
    };

    return params;
  }

  getData(): Observable<{
    status: boolean;
    message: string;
}> {
    return of({
      status: true,
      message: "slot changed",
    });
  }
}
